import script from "./TransactionNotesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionNotesDialog.vue?vue&type=script&setup=true&lang=js"

import "./TransactionNotesDialog.vue?vue&type=style&index=0&id=37cc33fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37cc33fc"]])

export default __exports__